import type { FunctionComponent } from "react";

import { sendGATracking } from "~/components/tracking/google-analytics/apis";

import { FacebookUrl, InstagramUrl, YoutubeUrl } from "./consts";
import { SocialMedia as SocialMediaEnum } from "./enums";
import FacebookIcon from "./icon-facebook.svg";
import InstagramIcon from "./icon-instagram.svg";
import YoutubeIcon from "./icon-youtube.svg";
import { Container, IconContainer } from "./styles";

type Props = {
  className?: string;
};

export const PostiesSocialMedia: FunctionComponent<Props> = ({ className }) => {
  const socialMediaMap = {
    [SocialMediaEnum.Facebook]: {
      icon: FacebookIcon,
      url: FacebookUrl,
    },
    [SocialMediaEnum.Instagram]: {
      icon: InstagramIcon,
      url: InstagramUrl,
    },
    [SocialMediaEnum.Youtube]: {
      icon: YoutubeIcon,
      url: YoutubeUrl,
    },
  };

  const getClickHandler = (media: SocialMediaEnum) => () => {
    const label = `${media.charAt(0).toUpperCase()}${media.slice(1)}`;
    sendGATracking({
      action: "Footer/Click",
      category: "Footer",
      label,
    });
  };

  const renderIcon = (media: SocialMediaEnum) => {
    const { icon: Component, url } = socialMediaMap[media];
    return (
      <IconContainer key={media}>
        <a href={url} rel="noopener noreferrer" target="_blank" onClick={getClickHandler(media)}>
          <Component />
        </a>
      </IconContainer>
    );
  };

  return (
    <Container className={className}>
      {[SocialMediaEnum.Facebook, SocialMediaEnum.Youtube, SocialMediaEnum.Instagram].map(media =>
        renderIcon(media),
      )}
    </Container>
  );
};

PostiesSocialMedia.displayName = "PostiesSocialMedia";
